<template lang="pug">
section.page-home.row
  idea-box(v-for="box, id in $root.account_boxes" :data="box" :key="id")
  button.add-idea-box.icon(@click="$root.new_box()" v-if="$root.permissions.includes('manage')")
    font-awesome-icon(icon="plus")

</template>
<script>
export default {
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
  computed: {
  }
}
</script>
<style>
.page-home .idea-box {
  max-width: 320px;
  min-width: 320px;
}
.mobile:not(.laptop) .page-home .idea-box {
  max-width: calc(100vw - 32px);
}
button.add-idea-box {
  height: 48px;
  width: 48px;
  padding: 4px;
  background: rgba(255,255,255,0.6);
  border-radius: 4px;
  z-index:1;
  margin-top: 32px;
  mix-blend-mode: hard-light;
  position: relative;
  margin-right: 32px;
}
button.add-idea-box:hover:after {
  position: absolute;
  top: 0;
  right:0;
  bottom:0;
  left: 0;
  content: "";
  background: rgba(0,0,0,0.1);
  border-radius: 4px;
}
.add-idea-box svg {
  color: gray;
}
.idea-box {
  margin-right: 16px;
}
/* componenents */
</style>
